import Typography from './Typography.component';

export default Typography;
